import * as React from 'react';
import { findIndex } from 'lodash';

import trackEvent from 'utilities/track_event';

import * as api from './api';
import { StudyScheduleDayData, StudyScheduleStore } from './types';

import ChangePlan from './change_plan';
import CurrentSchedule from './current_schedule';
import SelectSchedule from './select_schedule';
import IntroduceLSATStudySchedule from './introduce_lsat_study_schedule/template';

interface Props extends StudyScheduleStore {
  hidePlanOptions: () => void;
  setItemCompleted: (number, boolean) => void;
  setPlan: (StudyScheduleDetailData) => void;
  showPlanOptions: () => void;
  updateUserProfile: (any) => void;
}

export default class Template extends React.Component<Props> {
  handleChangePlan = (id: number) => {
    return api.setStudySchedule(id).then((plan) => {
      this.props.setPlan(plan);
      this.props.hidePlanOptions();
    });
  };

  handleChangeDay = (dayId: number) => {
    const planId = this.props.currentStudySchedule.id;

    return api.setStudyScheduleDay(planId, dayId).then((plan) => {
      this.props.setPlan(plan);

      // Track in Mixpanel
      const currentDay = (plan as any).currentDay;
      const dayIndex = findIndex((plan as any).days, (day: StudyScheduleDayData) => {
        return day.id === dayId;
      });
      trackEvent('Study Schedule > Set Day', {
        study_schedule_day_id: currentDay.id,
        study_schedule_day_name: `Day ${dayIndex + 1}: ${currentDay.name}`
      });
    });
  };

  handleChangeUserProfile = (userProfile: any) => {
    return api.updateUserProfile(userProfile).then(() => {
      return this.props.updateUserProfile(userProfile);
    });
  };

  handleOptOut = () => {
    trackEvent('Study Schedule > Opt Out');
    return api.setNoStudySchedule().then(() => {
      // We don't handle opting out to just see recommended lessons in this component, reload
      // so Rails takes care of it with it's existing HAML view
      window.location.reload();
    });
  };

  render() {
    const {
      currentStudySchedule,
      hidePlanOptions,
      showPlanOptions,
      studySchedules,
      showExamSectionFocusStep,
      ui: { presentPlanOptions },
      userProfile: { examName, studyExperience, testDate, examSectionFocus }
    } = this.props;

    if (currentStudySchedule && presentPlanOptions) {
      return (
        <div className="bg-gray-lightest border-radius-top border-radius-bottom u-margin-B-l">
          <ChangePlan
            currentPlan={currentStudySchedule}
            onCancel={hidePlanOptions}
            onComplete={this.handleChangePlan}
            plans={studySchedules}
          />
        </div>
      );
    } else if (currentStudySchedule) {
      return (
        <div className="bg-gray-lightest border-radius-top border-radius-bottom u-margin-B-l">
          <CurrentSchedule
            onChangePlan={this.props.studySchedules.length > 1 ? showPlanOptions : null}
            onSetCurrentDay={this.handleChangeDay}
            examName={this.props.userProfile.examName}
            {...currentStudySchedule}
          />
        </div>
      );
    } else {
      if (this.props.userProfile.examName === 'LSAT') {
        return (
          <IntroduceLSATStudySchedule
            examName={examName}
            onSkip={this.handleOptOut}
            schedules={studySchedules}
            onSelect={this.handleChangePlan}
          />
        );
      } else {
        return (
          <SelectSchedule
            examName={examName}
            onSelect={this.handleChangePlan}
            onSkip={this.handleOptOut}
            onUpdateUserProfile={this.handleChangeUserProfile}
            schedules={studySchedules}
            studyExperience={studyExperience}
            testDate={testDate}
            showExamSectionFocusStep={showExamSectionFocusStep}
            examSectionFocus={examSectionFocus}
          />
        );
      }
    }
  }
}
